const COOKIE_NAME = 'lm_vid';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 180;
const STORAGE_KEY = 'lm_vid';

const readCookie = () => {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]+)`));
    return match ? decodeURIComponent(match[1]) : null;
};

const writeCookie = (value: string) => {
    if (typeof document === 'undefined') return;
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; Max-Age=${COOKIE_MAX_AGE}; Path=/; SameSite=Lax`;
};

const isValidVisitorId = (value: string | null | undefined) => Boolean(value && /^[a-f0-9-]{36}$/i.test(value));

export const getOrCreateVisitorId = () => {
    if (typeof window === 'undefined') return null;

    const cookieValue = readCookie();
    const storageValue = window.localStorage.getItem(STORAGE_KEY);
    const existing = isValidVisitorId(cookieValue) ? cookieValue : isValidVisitorId(storageValue) ? storageValue : null;

    if (existing) {
        writeCookie(existing);
        window.localStorage.setItem(STORAGE_KEY, existing);
        return existing;
    }

    const generated = crypto.randomUUID();
    writeCookie(generated);
    window.localStorage.setItem(STORAGE_KEY, generated);
    return generated;
};
